import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import React from 'react';

export interface StandardButtonProps extends ButtonProps {
  main?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
}

export const StandardButton = React.forwardRef((props: StandardButtonProps, ref) => {
  const { main = false, loading, children, disabled, ...buttonProps } = props;

  const buttonStyle = { minWidth: '100px' };

  return (
    <Button
      ref={ref as React.MutableRefObject<HTMLButtonElement>}
      variant={main ? 'contained' : 'text'}
      color={'secondary'}
      style={buttonStyle}
      disabled={disabled || loading}
      {...buttonProps}
      startIcon={loading ? null : buttonProps.startIcon}
      endIcon={loading ? null : buttonProps.endIcon}
    >
      {loading ? (
        <CircularProgress size={props.size === 'small' ? 16 : 22} color={'secondary'} style={{ paddingBlock: '3px' }} />
      ) : (
        children
      )}
    </Button>
  );
});
